import DealTypeTabs from './DealTypeTabs';

export default DealTypeTabs;
